/*
 * @Author: edvardchen
 * @Date:   2016-10-24 22:25:04
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:36:36
 */

import PropTypes from 'prop-types';
import React from 'react';
import autobind from 'core-decorators/lib/autobind';

import Image from '../Image';
import VideoPlayInLine from '../VideoPlayInLine';
import { center as Loading } from '../Loading';
import withPlayContext from '../../HOCs/withPlayContext';
import { contextTypes } from '../../HOCs/withRoute';

import {
  // isomorphicConfig,
  offset,
} from '../../utility';

import styles from './Video.scss';
import base from '../../containers/base.scss';

const PADDING = '56.25%';

class MediaVideo extends React.PureComponent {
  static propTypes = {
    image: PropTypes.string,
    duration: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    vid: PropTypes.string,
    onPlay: PropTypes.func, // 播放成功回调
  };

  static contextTypes = contextTypes;

  state = { hidePlaceHolder: false };

  componentDidMount() {
    const { listenToVideoPlay } = this.context;
    if (listenToVideoPlay) {
      this.videoWatching = listenToVideoPlay(({ vid }) => {
        if (vid !== this.props.vid) {
          this.setState({
            hidePlaceHolder: false,
            playing: false,
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this.videoWatching && this.videoWatching.remove();
  }

  @autobind
  onCanPlayThrough() {
    const { onVideoPlay } = this.context;
    if (onVideoPlay) {
      onVideoPlay(this.props);
    }
  }

  @autobind
  startPlay(event) {
    event.preventDefault();
    const { onPlay } = this.props;
    if (this.context.canPlayEpisode()) {
      this.context.playEpisode(
        {
          ...this.props,
          rect: offset(this.el),
        },
        () => {
          onPlay && onPlay(null, this.props);
        },
      );
      this.setState({ playing: true });
      return;
    }
    this.setState({
      loading: true,
    });
    this.context.sniff(this.props).then(({ url }) => {
      this.setState({
        playing: true,
        realPlayUrl: url,
        hidePlaceHolder: true,
        loading: false,
      });
      onPlay && onPlay(null, this.props);
    });
  }

  render() {
    const { realPlayUrl, hidePlaceHolder, loading } = this.state;
    const { image, title, duration, subTitle } = this.props;

    let content;
    if (!hidePlaceHolder) {
      content = (
        <div onClick={this.startPlay} style={{ width: '100%' }}>
          <Image src={image} initPadding={PADDING}>
            {loading ? <Loading /> : <span className={`${base.playIcon} ${styles.btnWrap}`}></span>}
            {duration && (
              <span className="mod-masktxt">
                <span>{duration}</span>
              </span>
            )}
          </Image>
        </div>
      );
    } else {
      const style = {
        width: '100%',
        paddingBottom: PADDING,
      };
      content = (
        <div style={style}>
          <VideoPlayInLine
            src={realPlayUrl}
            poster={image}
            controls
            autoPlay
            onCanPlayThrough={this.onCanPlayThrough}
          />
        </div>
      );
    }

    return (
      <div className="mod-card-container-album2">
        <div
          className="mod-feed-image is-1pic"
          ref={(node) => {
            this.el = node;
          }}
        >
          {content}
        </div>
        <div className="txt-con">
          <h2 className="mod-feed-title">{title}</h2>
          <p className="sub-title">{subTitle}</p>
        </div>
      </div>
    );
  }
}

export default withPlayContext(MediaVideo);
